import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { tileDataProp } from 'components/atoms/TileButton';
import React, { FC } from 'react';
import tw from 'twin.macro';
import { FileAddOutlined } from '@ant-design/icons';

export const CustomTab = styled(Tabs)`
    .ant-tabs-tab {
        margin: 0px !important;
        border: none !important;
        border-radius: 3px 3px 0px 0px !important;
        background: none !important;
    }
    .ant-tabs-tab-active {
        background: white !important;
    }
    .ant-tabs-tab-active .ant-tabs-tab-btn {
        ${tw`!text-blackAlt`}
        text-shadow:none !important;
    }
    .ant-tabs-nav {
        ${tw`bg-backgroundGreyAlt1`}
        ${tw`border border-borderLinePurpuleAlt`}
        border-bottom:none;
        border-radius: 4px;
        padding: 8px 8px 0px 8px;
        margin-bottom: 0px !important;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
    .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
        background: none !important;
    }
    .ant-tabs-nav:before {
        border-bottom: none !important;
    }
`;
type Props = {
    activeKey: string;
    setActiveKey: Function;
    items: TabType[];
    customTabsObj?: Array<{ label: any; key: string }>;
};

type TabType = {
    key: string;
    label: any;
    dataKey?: string;
};
const TabsContainer: FC<Props> = ({ activeKey, setActiveKey, items = [], customTabsObj }) => {
    const updatedItems = [...items];
    const customKeys = customTabsObj?.map((i: any) => i.key);
    if (customTabsObj?.length) {
        updatedItems.push(...customTabsObj);
    }

    return (
        <div className="card-container">
            <CustomTab
                className="card-container"
                type={'card'}
                activeKey={activeKey}
                onChange={(key) => {
                    if (!customKeys?.includes(key)) setActiveKey(key);
                }}
                items={updatedItems}
            />
        </div>
    );
};

export default TabsContainer;
